import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import therapistReducer from "./therapistSlice";
import requestReducer from "./requestSlice";
import reviewReducer from "./reviewSlice";
import supportReducer from "./supportSlice";
import branchReducer from "./branchSlice";
import meetingReducer from "./meetingSlice";
import verificationReducer from "./verificationSlice";
import usersReducer from "./userSlice";
import questionReducer from "./questionSlice";
import AvailabilityReducer from "./availabilitySlice";
import paymentReducer from "./paymentSlice";
import languageReducer from "./languageSlice";
import expertisesReducer from "./expertisesSelice";
import uploadReducer from "./uploadSlice";
import packagesReducer from "./packagesSlice";
import walletReducer from "./walletSlice";
import therapistPaymentReducer from "./therapistPeymentSlice";
import cookieReducer from "./cookieSlice";
import testReducer from "./testSlice";
import stripeReducer from "./stripeSlice";
import blogReducer from "./blogSlice";
import chatReducer from "./chatSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    availability: AvailabilityReducer,
    therapist: therapistReducer,
    requests: requestReducer,
    reviews: reviewReducer,
    support: supportReducer,
    branches: branchReducer,
    meeting: meetingReducer,
    verification: verificationReducer,
    users: usersReducer,
    questions: questionReducer,
    payment: paymentReducer, 
    languages: languageReducer,
    expertises: expertisesReducer,
    upload: uploadReducer,
    packages: packagesReducer,
    wallet: walletReducer,
    therapistPayments: therapistPaymentReducer,
    cookie: cookieReducer,
    tests: testReducer,
    stripe: stripeReducer,
    blogs: blogReducer,
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;